module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-3.45c89a5b.svg";